import React, { useRef } from 'react'

import { InputGroup, InputGroupText } from 'twyne-new.ui'

import AutocompleteInput from '@Components/AutocompleteInput'

import MergetagPopover from './Popover'

export default function MergetagInput({ value, onChange, mergetags = [], className = '', maxOptions = 0, disabled, disabledMergetag, ...props }) {
  const wrapperRef = useRef(null)
  const selectionRef = useRef(null)

  const handleBlur = ({ target }) => {
    if (target.tagName === 'INPUT') {
      selectionRef.current = { start: target.selectionStart, end: target.selectionEnd }
    }
  }

  const handleInsert = tag => {
    const text = `${value || ''}`
    const { start = text.length, end = text.length } = selectionRef.current || {}
    const mergetag = `{${tag}}`
    const cursor = start + mergetag.length

    onChange(`${text.slice(0, start)}${mergetag}${text.slice(end)}`)
    selectionRef.current = { start: cursor, end: cursor }

    requestAnimationFrame(() => {
      const element = wrapperRef.current?.querySelector('input')
      element?.focus()
      element?.setSelectionRange(cursor, cursor)
    })
  }

  return <div ref={wrapperRef} className='w-full' onBlur={handleBlur}>
    <InputGroup className='w-full'>
      <AutocompleteInput
        {...props}
        className={`${className} rounded-r-none!`}
        value={value}
        onChange={onChange}
        trigger={['{']}
        options={{ '{': mergetags }}
        maxOptions={maxOptions}
        disabled={disabled}
      />
      <InputGroupText addonType='append' className='p-0' aria-disabled={disabled}>
        <MergetagPopover mergetags={mergetags} onSelect={handleInsert} disabled={disabled || disabledMergetag} />
      </InputGroupText>
    </InputGroup>
  </div>
}
